"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**
 * @hidden
 */
var DragClue = /** @class */ (function (_super) {
    __extends(DragClue, _super);
    function DragClue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
            top: 0,
            left: 0,
            innerText: '',
            status: 'k-i-cancel'
        };
        return _this;
    }
    DragClue.prototype.render = function () {
        return this.state.visible && (React.createElement("div", { className: "k-header k-drag-clue", style: {
                display: 'block',
                position: 'absolute',
                zIndex: 20000,
                padding: '8px 12px',
                top: this.state.top + 'px',
                left: this.state.left + 'px'
            } },
            React.createElement("span", { className: 'k-icon k-drag-status ' + this.state.status + ' k-icon-with-modifier' },
                React.createElement("span", { className: "k-icon k-icon-modifier" })),
            this.state.innerText));
    };
    return DragClue;
}(React.PureComponent));
exports.DragClue = DragClue;
//# sourceMappingURL=DragClue.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-data-tools@3.18.0_bwv2g72eb344voeanxti7iyzje/~/@progress/kendo-react-data-tools/dist/npm/drag/DragClue.js
// module id = 6482
// module chunks = 0